// react
import React from 'react';

import FAutoComplete from './FAutoComplete';
import FAutoIDField from './FAutoIDField';
import FCheckGroup from './FCheckGroup';
import FChoice from './FChoice';
import FComboBox from './FComboBox';
import FDateField from './FDateField';
import FDisplayField from './FDisplayField';
import FFileData from './FFileData';
import FFileField from './FFileField';
import FFileUpload from './FFileUpload';
import FGeoLocation from './FGeoLocation';
import FImageField from './FImageField';
import FJsonField from './FJsonField';
import FMaskField from './FMaskField';
import FMaskListField from './FMaskListField';
import FMultiLevelCombo from './FMultiLevelCombo';
import FNumberField from './FNumberField';
import FPasswordField from './FPasswordField';
import FPhotoField from './FPhotoField';
import FPhoneField from './FPhoneField';
import FRadioGroup from './FRadioGroup';
import FSlider from './FSlider';
import FTagField from './FTagField';
import FTextArea from './FTextArea';
import FTextField from './FTextField';
import FMultiSelect from './FMultiSelect';

/**
 * -------------------------------------------------------------------
 * Local Form Fields used in action forms
 * -------------------------------------------------------------------
 */
const ff:any = {
  ai:<FAutoIDField/>,
  cb:<FComboBox/>,
  cg:<FCheckGroup/>,
  ch:<FChoice/>,
  df:<FDateField/>,
  fa:<FAutoComplete/>,
  fd:<FFileData/>,
  ff:<FFileField/>,
  ft:<FTagField/>,
  fu:<FFileUpload/>,
  gl:<FGeoLocation/>,
  if:<FImageField/>,
  jf:<FJsonField/>,
  mc:<FMultiLevelCombo/>,
  ms:<FMultiSelect/>,
  mf:<FMaskField/>,
  ml:<FMaskListField/>,
  nf:<FNumberField/>,
  pf:<FPasswordField/>,
  ph:<FPhotoField />,
  pn:<FPhoneField />,
  rf:<FDisplayField/>,
  rg:<FRadioGroup/>,
  sl:<FSlider/>,
  ta:<FTextArea/>,
  tf:<FTextField/>
};
//export {cg:ff.cg,ch:ff.ch,cb:ff.cb,df:ff.df,rf:ff.rf,fu:ff.fu,if:ff.if,nf:ff.nf,rg:ff.rg,sl:ff.sl,tf:ff.tf,ta:ff.ta};
export default ff;
